import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Link } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<Link>>>;

const getLinksForOrganization = (id: string): ReturnType => {
    return Request.get(`/links/organization/${id}`);
};

export default getLinksForOrganization;
